import { combineEpics } from 'redux-observable';

import { _reducer } from './assessments.reducers';
import { _reducer as groupAssessmentsReducer } from './assessmentGroups.reducers';
import _epics from './assessments.epics';

export const epics = combineEpics(_epics);
export { _reducer, groupAssessmentsReducer };
export * from './assessments.actions';
